<template>
  <svg width="72" height="72" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="#2F75FF" d="M28 25h19l-3 6H25z" />
      <path fill="#FFC760" d="M28 33h19l-3 6H25z" />
      <path fill="#6BCFFF" d="M28 41h19l-3 6H25z" />
    </g>
  </svg>
</template>
